import { Box, Typography, Paper } from "@mui/material";

export default function FormCard({
  title,
  subtitle,
  onClick,
  disabled = false,
  disabledNote,
}) {
  return (
    <Paper
      component="a"
      href="#"
      onClick={!disabled ? onClick : undefined}
      role={disabled ? undefined : "button"}
      elevation={3}
      tabIndex={disabled ? -1 : 0}
      sx={{
        p: 3,
        borderRadius: 2,
        height: "100%",
        cursor: disabled ? "default" : "pointer",
        opacity: disabled ? 0.5 : 1,
        pointerEvents: disabled ? "none" : "auto",
        transition: "transform 0.2s, box-shadow 0.2s",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        textDecoration: "none",
        "&:hover": {
          transform: disabled ? "none" : "translateY(-4px)",
          boxShadow: disabled ? 3 : 6,
        },
        "&:focus": {
          outline: disabled ? "none" : "2px solid #850C70",
        },
      }}
    >
      <Box>
        <Typography variant="h5" fontWeight={700} gutterBottom>
          {title}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {subtitle}
        </Typography>
      </Box>
      {disabled && disabledNote && (
        <Typography
          variant="body2"
          color="text.primary"
          sx={{ fontStyle: "italic" }}
        >
          {disabledNote}
        </Typography>
      )}
    </Paper>
  );
}
